import { Component } from '@angular/core';

import { OffCanvasComponentSelector } from '../off-canvas-form.component';
import { getOffCanvasIdFromLevel, OffCanvasPlacement } from '@optima-stride-ai/optima-components';


@Component({
  selector: 'app-off-canvas-collective',
  imports: [ OffCanvasComponentSelector],
  templateUrl: './off-canvas-collective.component.html',
  styleUrl: './off-canvas-collective.component.scss'
})
export class OffCanvasCollectiveComponent {

    
  get offCanvasPlacement() {
    return OffCanvasPlacement;
  }
  getOffCanvasIDForLevel(level: number, placement: OffCanvasPlacement = OffCanvasPlacement.End) {
    return getOffCanvasIdFromLevel(level, placement);
  }
}